import React from 'react';
import { FormattedMessage } from 'react-intl';
import { InputBox } from '../../molecules/input-box';

export const ServiceAccessInput = () => {
  return (
    <InputBox
      title={
        <FormattedMessage
          id="expertService.password"
          defaultMessage="Přístup do servisu"
        />
      }
      inputVariableId="SERVICE_PASSWORD"
      label={
        <FormattedMessage
          id="expertService.password.label"
          defaultMessage="Heslo"
        />
      }
      fullWidth
    />
  );
};
